/* Navbar search (20 Oct 2026): opens on tap below 1200px, and shows product suggestions while typing (Shopify's own suggest endpoint, the .json version). */
(function () {
  var root = document.querySelector('.site-header__search');
  if (!root) return;

  var toggle = root.querySelector('.site-header__search-toggle');
  var form = root.querySelector('.site-header__search-form');
  var input = root.querySelector('.site-header__search-input');
  var panel = root.querySelector('.site-header__search-panel');
  var suggestUrl = root.getAttribute('data-suggest-url') + '.json';
  var searchUrl = root.getAttribute('data-search-url');
  var currency = root.getAttribute('data-currency') || 'EUR';
  var labelAll = root.getAttribute('data-all') || 'Vedi tutti i risultati';
  var labelNone = root.getAttribute('data-none') || 'Nessun risultato';
  var timer = null;
  var controller = null;

  function esc(text) {
    var div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML.replace(/"/g, '&quot;');
  }

  function money(value) {
    var number = parseFloat(value);
    if (isNaN(number)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(number);
    } catch (e) {
      return number.toFixed(2) + ' ' + currency;
    }
  }

  function closePanel() {
    panel.hidden = true;
    panel.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  function openBar() {
    root.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input.focus(); }, 30);
  }

  function closeBar() {
    root.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    closePanel();
  }

  function render(products, query) {
    var html = '';
    if (!products.length) {
      html = '<span class="site-header__sg-none">' + esc(labelNone) + '</span>';
    } else {
      products.forEach(function (product) {
        var image = '';
        if (product.featured_image && product.featured_image.url) {
          var src = product.featured_image.url;
          src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=88';
          image = '<img src="' + esc(src) + '" alt="" width="44" height="44" loading="lazy">';
        }
        html += '<a class="site-header__sg" href="' + esc(product.url) + '">' + image +
          '<span><span class="site-header__sg-title">' + esc(product.title) + '</span>' +
          '<span class="site-header__sg-price">' + esc(money(product.price)) + '</span></span></a>';
      });
      html += '<a class="site-header__sg-all" href="' + esc(searchUrl + '?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last') + '">' + esc(labelAll) + '</a>';
    }
    panel.innerHTML = html;
    panel.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function fetchSuggestions() {
    var query = input.value.trim();
    if (query.length < 2) {
      closePanel();
      return;
    }
    if (controller) controller.abort();
    controller = typeof AbortController === 'function' ? new AbortController() : null;
    var requestUrl = suggestUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5';
    fetch(requestUrl, controller ? { signal: controller.signal } : undefined)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (input.value.trim() === query) render(products, query);
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(fetchSuggestions, 200);
  });

  input.addEventListener('focus', function () {
    if (input.value.trim().length >= 2 && panel.hidden) fetchSuggestions();
  });

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (root.classList.contains('is-open')) {
        closeBar();
      } else {
        openBar();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!panel.hidden) closePanel();
    if (root.classList.contains('is-open')) {
      closeBar();
      if (toggle) toggle.focus();
    }
  });

  document.addEventListener('click', function (event) {
    if (root.contains(event.target)) return;
    closePanel();
    if (root.classList.contains('is-open')) closeBar();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1199 && root.classList.contains('is-open')) closeBar();
  });

  form.addEventListener('submit', function (event) {
    if (input.value.trim() === '') event.preventDefault();
  });
})();
